import { Dropdown } from "react-bootstrap";
import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";

export default class EssenceActionsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: [],
      show: false,
      triggerRef: React.createRef(),
    };
  }
  onOpen = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ show: true });
  };
  onFinish = (method) => {
    this.setState({ show: false });
    if (method.actioncode === "drop") {
      if (this.props.onDrop) {
        this.props.onDrop(method);
        return;
      }
    }

    let shouldMakeClick = true;
    if ((this.props.attendantItems || []).length > 0) shouldMakeClick = false;
    if (this.props.keepOpen) shouldMakeClick = false;
    if (this.state.triggerRef?.current && shouldMakeClick) {
      this.state.triggerRef.current.click();
    }

    if (this.props.onFinish) {
      this.props.onFinish(method);
    }
  };

  render() {
    return (
      <>
        <div className="essence-actions" onClick={(e) => e.stopPropagation()}>
          <Dropdown>
            <Dropdown.Toggle
              as={DropdownToggle}
              id="dropdown-actions"
              ref={this.state.triggerRef}
            >
              <i className="fa icon-lg fa-ellipsis-v pt-1"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <ActionsList
                essence={this.props.essence}
                key={this.props.id}
                id={this.props.id}
                attendantItems={this.props.attendantItems}
                label={this.props.label}
                onFinish={this.onFinish}
                onPending={this.props.onPending}
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>
    );
  }
}

class ActionsList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      method: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ pending: true });

    let method = await this.context.api.qa(`/object/method`, {
      id: this.props.id,
    });

    method = method.filter((m) => m.visible);

    this.setState({ pending: false, method });
  };

  ask = async (method) => {
    let attendantItemsLength = this.props.attendantItems?.length;

    if (attendantItemsLength) {
      if (!this.props.attendantItems.includes(this.props.id))
        attendantItemsLength++;

      if (attendantItemsLength > 1) {
        let result = await this.context.ask(
          `Вы действительно хотите выполнить действие "${method.label}" для нескольких (${attendantItemsLength}) объектов?`
        );
        if (!result.value) return;
      }
    }

    if (method.actioncode === "drop") {
      let result = await this.context.ask(
        `Вы действительно хотите выполнить действие "${method.label}" для "${this.props.label}"`,
        "Подтверждение действия",
        "question"
      );

      if (!result.value) return;
    }

    this.run(method);
  };

  run = async (method) => {
    this.setState({ pending: true });
    if (this.props.onPending) this.props.onPending(true);

    let result = this.props.attendantItems?.length
      ? await this.runMultiple(method)
      : await this.runSingle(method);

    if (this.props.onPending) this.props.onPending(false);
    if (result) {
      this.finish(method);
    } else {
      this.context.toast(
        `Не удалось выполнить действите "${method.label}"`,
        "error"
      );

      this.setState({ pending: false });
    }
  };

  runSingle = async (method) => {
    let result = await this.context.api.q("/method/run", {
      id: this.props.id,
      method: method.id,
    });
    if (result !== false) {
      this.onAfterRunResult(result);
      this.context.toast(`Действите "${method.label}" выполнено`, "success");
      return true;
    }
    return false;
  };

  runMultiple = async (method) => {
    let queryParams = this.props.attendantItems.map((id) => {
      return {
        key: id,
        path: "/api/v1/method/run",
        payload: {
          id,
          method: method.id,
        },
      };
    });

    let result = await this.context.api.qa("/run", queryParams);
    if (result && Array.isArray(result)) {
      result.forEach((r) => {
        if (Array.isArray(r.payload)) {
          this.onAfterRunResult(r.payload[0]);
        }
      });

      this.context.toast(`Действите "${method.label}" выполнено`, "success");
      return true;
    }
    return false;
  };

  onAfterRunResult = (result = {}) => {
    if (result?.newstate) {
      let items = {};
      items[result.object] = {
        statenewlabel: result.newstate.label,
        statenewtypecode: result.newstate.typecode,
      };
      window.dispatchEvent(
        new CustomEvent("onlineChanged", { detail: { items } })
      );
    }
  };

  finish = (method) => {
    this.load();
    if (this.props.onFinish) {
      this.props.onFinish(method);
    }
  };

  render() {
    return (
      <>
        <Blocker on={this.state.pending}>
          {this.state.method.length === 0 ? (
            <div className="p-4">
              <span className="text-center text-muted font-italic">
                Нет доступных действий
              </span>
            </div>
          ) : null}
          {this.state.method.length > 0 ? (
            <div>
              {this.state.method.map((method = {}) => {
                if (!method.visible) return null;
                let enabled = method.enable && method.execute;
                return (
                  <div
                    key={method.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (enabled) this.ask(method);
                    }}
                    className={`dropdown-item text-center  ${
                      enabled ? "cursor-pointer" : "text-muted"
                    }`}
                  >
                    {method.label}
                  </div>
                );
              })}
            </div>
          ) : null}
        </Blocker>
      </>
    );
  }
}

const DropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    title="Меню действий"
    ref={ref}
    className={`cursor-pointer text-light text-hover-primary px-1`}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));
